module.exports = __webpack_public_path__ + "img/madrid2.e1ac3d58.png";